// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css'; // Your global styles
import App from './App';
import ReactGA from 'react-ga4';
ReactGA.initialize('G-QQM90ZNXBS');
// Create a root element for React 18
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);